import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBillingAmericanExpress = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 128,
	height: 86,
	viewBox: "0 0 128 86",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_3_4439)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M0 12C0 5.37258 5.37258 0 12 0H116C122.627 0 128 5.37258 128 12V74C128 80.6274 122.627 86 116 86H12C5.37258 86 0 80.6274 0 74V12Z",
				fill: "#1D71B9"
			}),
			/* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M77.2165 69.9324V41.3595L128.071 41.4062V49.2987L122.192 55.5785L128.071 61.9188V69.9774H118.686L113.699 64.4747L108.747 69.9999L77.2165 69.9324Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M80.6133 66.7985V44.5036H99.5184V49.6395H86.7356V53.1264H99.2138V58.1775H86.7356V61.602H99.5184V66.7985H80.6133Z",
				fill: "#1D71B9"
			}),
			/* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M99.4249 66.7984L109.884 55.6388L99.4249 44.5052H107.52L113.912 51.5706L120.322 44.5052H128.071V44.68L117.833 55.6388L128.071 66.4835V66.7984H120.244L113.739 59.6621L107.3 66.7984H99.4249Z",
				fill: "#1D71B9"
			}),
			/* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M79.5889 16H91.8473L96.1527 25.777V16H111.287L113.897 23.3249L116.515 16H128.071V44.5712H67L79.5889 16Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M81.9112 19.1045L72.0182 41.3804H78.8033L80.6687 36.9193H90.7814L92.6468 41.3804H99.5997L89.7483 19.1045H81.9112ZM82.7608 31.9201L85.7268 24.8288L88.691 31.9201H82.7608Z",
				fill: "#1D71B9"
			}),
			/* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M99.508 41.3767V19.1008L109.044 19.1336L113.952 32.8283L118.892 19.1008H128.071V41.3767L122.165 41.4286V26.1263L116.589 41.3767H111.197L105.506 26.0744V41.3767H99.508Z",
				fill: "#1D71B9"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_3_4439",
		children: /* @__PURE__ */ _jsx("path", {
			d: "M0 12C0 5.37258 5.37258 0 12 0H116C122.627 0 128 5.37258 128 12V74C128 80.6274 122.627 86 116 86H12C5.37258 86 0 80.6274 0 74V12Z",
			fill: "white"
		})
	}) })]
});
export default SvgBillingAmericanExpress;
